import { useState } from 'react'
import { useGetCasSharePointResourcesQuery } from 'schema'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'
import { CIMSModal } from 'components/CIMSModal'
import { Report } from '@cims-online/shared'
import { errorHandler } from 'hooks/errorHandler'
import { List } from 'antd'
import { FileImageOutlined } from '@ant-design/icons'
import CIMSLink from 'components/CIMSLink'
import CIMSSelect from 'components/CIMSSelect'
import { useReportURLDependencies } from 'hooks/useReportURLDependencies'
import { useSubmittalTrackerContext } from '../../../../SubmittalTrackerContext'

const PDFModal: React.VFC = () => {
  const { pdfModal, refetch } = useSubmittalTrackerContext()
  const { state, toggle, visible } = pdfModal
  const [wasGenerated, setWasGenerated] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState<string[]>([])
  const dependencies = useReportURLDependencies()
  const { id } = state ?? {}
  const { data, loading } = useGetCasSharePointResourcesQuery({
    ...DefaultQueryHookOptions,
    skip: !id,
    variables: { id: id! },
  })
  const resources =
    data?.constructionAdminSubmittal?.sharePointResource?.sharePointResources
  const resourceMap = new Map(
    resources ? resources.map((resource) => [resource.id, resource]) : []
  )
  const options = useOptions({
    items: resources?.filter(
      ({ id }) =>
        id !== data?.constructionAdminSubmittal?.packetSharePointResourceId
    ),
    value: 'id',
    label: 'name',
    sort: 'name',
  })
  return (
    <CIMSModal
      title="Create Construction & Admin Submittal Packet"
      visible={visible}
      onCancel={() => {
        setWasGenerated(false)
        setSelectedFiles([])
        toggle(null)
      }}
      disabled={!state || wasGenerated || loading}
      onOk={() => {
        try {
          const tab = window.open(
            Report.ConstructionAdminSubmittal.toURL({
              ...dependencies,
              recordId: state!.id,
              driveItemIds: selectedFiles.length ? selectedFiles : undefined,
            })
          )
          if (!tab) throw new Error('Failed to create packet')
          setWasGenerated(true)
          tab.onbeforeunload = () => refetch()
        } catch (err) {
          errorHandler(err)
        }
      }}
    >
      <List
        header="Currently Selected Files"
        itemLayout="horizontal"
        dataSource={selectedFiles}
        loading={loading}
        renderItem={(id) => {
          const resource = resourceMap.get(id)
          return (
            <List.Item>
              <List.Item.Meta
                avatar={<FileImageOutlined />}
                title={
                  <CIMSLink external href={resource?.webUrl}>
                    {resource?.name}
                  </CIMSLink>
                }
              />
            </List.Item>
          )
        }}
      />
      <CIMSSelect
        simple
        mode="multiple"
        placeholder="Selected files are staged to be added to the generated pdf in selection order"
        onChange={(selectedValues) => {
          setSelectedFiles(selectedValues as string[])
        }}
        options={options}
        loading={loading}
        style={{ width: '100%' }}
      />
    </CIMSModal>
  )
}

export default PDFModal
